import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { AuthShell, inputClass } from "./Login";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(email, password, name);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Create your Rolodex" subtitle="Get started free">
      <form onSubmit={submit} className="space-y-4">
        {error && (
          <div data-testid="register-error" className="text-sm text-red-400 bg-red-950/40 border border-red-900/60 rounded-lg px-3 py-2">
            {error}
          </div>
        )}
        <div>
          <label className="text-xs text-slate-400 mb-1.5 block">Name</label>
          <input
            data-testid="register-name-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Jeremy Spear"
            className={inputClass}
          />
        </div>
        <div>
          <label className="text-xs text-slate-400 mb-1.5 block">Email</label>
          <input
            data-testid="register-email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            className={inputClass}
          />
        </div>
        <div>
          <label className="text-xs text-slate-400 mb-1.5 block">Password</label>
          <input
            data-testid="register-password-input"
            type="password"
            required
            minLength={6}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="At least 6 characters"
            className={inputClass}
          />
        </div>
        <button
          data-testid="register-submit-button"
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 hover:bg-blue-500 text-white font-semibold rounded-xl py-3 flex items-center justify-center transition-colors disabled:opacity-60"
        >
          {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Create account"}
        </button>
      </form>
      <p className="text-sm text-slate-400 mt-6 text-center">
        Already have an account?{" "}
        <Link to="/login" className="text-blue-500 hover:text-blue-400 font-medium">
          Sign in
        </Link>
      </p>
    </AuthShell>
  );
}
